import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Icons } from '@vex/icons/icons';
import {
  MonacoEditorComponent,
  MonacoEditorConstructionOptions,
  MonacoEditorLoaderService,
  MonacoStandaloneCodeEditor
} from '@materia-ui/ngx-monaco-editor';
import { DeviceService } from '@vex/http-service/device.service';
import { ComplianceParameterType } from '@vex/model/data-center-site';
import { ToastrService } from 'ngx-toastr';
import { IpRangeValidator } from '@vex/utils/IpRangeValidators';
import { FormControl } from '@angular/forms';
import moment from 'moment';
import { InventoryService } from '@vex/http-service/inventory.service';
import { BlueprintService } from '@vex/http-service/blueprint.service';
import {cloneDeep} from 'lodash';
import { BlueprintCollection } from '@vex/model/blueprint-list';

@Component({
  selector: 'elastic-view-diff-code',
  templateUrl: './view-diff-code.component.html',
  styleUrls: ['./view-diff-code.component.scss']
})
export class ViewDiffCodeComponent extends Icons implements OnInit {
  loadEditor: boolean = true;
  editorOptions: MonacoEditorConstructionOptions = {
    theme: 'vs-dark',
    language: 'json',
    roundedSelection: true,
    autoIndent: 'full',
    readOnly: false,
    showDeprecated: false,
    wordWrap: 'on'
  };
  configurationLoader: boolean = false;
  isEditorShowSeprate: boolean = false;
  isEditorShowSeprateOption2: boolean = false;
  isEditorShowSeprateOption3: boolean = false;
  configurationLoaderV2: boolean = false;
  configurationLoaderV3: boolean = false;
  compareData: any = {};
  compareDataV2: any = {};
  compareDataV3: any = {};
  configurationCounter = 0;
  configurationCounterV2 = 0;
  configurationCounterV3 = 0;
  loadingOption2: boolean = false;
  loadingOption3: boolean = false;
  loadedOption2: boolean = false;
  loadedOption3: boolean = false;
  rawCollections: any[] = [];
  dialog_title: string = '';
  sourceInventoryId: string = '';
  targetInventory: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ViewDiffCodeComponent>,
    private inventoryService: InventoryService,
    private blueprintService: BlueprintService,
    private deviceService: DeviceService,
    private toaster: ToastrService
  ) {
    super();
    if(this.data.title) {
      this.dialog_title = this.data.title;
    }
    this.sourceInventoryId = this.data.SourceInventoryId || '';
    this.targetInventory = this.data.TargetInventory;
  }

  editorInit(editor: MonacoStandaloneCodeEditor) {
    this.loadEditor = false;
    editor.setSelection({
      startLineNumber: 1,
      startColumn: 1,
      endColumn: 100,
      endLineNumber: 100
    });
  }

  ngOnInit() {
    this.toaster.info("Please wait we are getting device changes");
    this.compareInventory();
  }

  onSelectTab(event) {
    if(event == 1 && !this.loadedOption2 && !this.loadingOption2) {
      this.compareInventoryV2()
    }
    if(event == 2 && !this.loadedOption3 && !this.loadingOption3) {
      this.compareInventoryV3()
    }
  }

  compareInventoryV2() {
    this.loadingOption2 = true;
    this.configurationLoaderV2 = false;
    this.configurationCounterV2 = 0;
    this.compareDataV2 = {};
    this.deviceService.getDeviceFilteredResourcesByJob([this.targetInventory]).subscribe(
      (inventories: any[]) => {
        this.getTerraformCodeByObjV2(inventories?.[0], 'Source');
        this.getTerraformCodeByObjV2(this.targetInventory, 'Target');
      },
      () => {
        this.compareDataV2.SourceCode = '';
        this.compareDataV2.TargetCode = '';
        this.requestCompletedConfigurationV2 = 2;
      }
    );
  }

  getTerraformCodeByObjV2(data, type: string = 'Source') {
    if (!data) {
      this.compareDataV2[type + 'Code'] = '';
      this.requestCompletedConfigurationV2 = ++this.configurationCounterV2;
      return;
    }

    this.blueprintService.getTerraformCode({inventory: data}).subscribe((response: any) => {
      this.compareDataV2[type + 'Code'] = this.getGeneratedCode(response);
      this.requestCompletedConfigurationV2 = ++this.configurationCounterV2;
    }, () => {
      this.compareDataV2[type + 'Code'] = '';
      this.requestCompletedConfigurationV2 = ++this.configurationCounterV2;
    });
  }

  set requestCompletedConfigurationV2(val: number) {
    if (val === 2) {
      this.configurationLoaderV2 = true;
      this.loadingOption2 = false;
      this.loadedOption2 = true;
    }
  }

  compareInventoryV3() {
    this.loadingOption3 = true;
    this.configurationLoaderV3 = false;
    this.configurationCounterV3 = 0;
    this.compareDataV3 = {};
    this.deviceService.applyDeploymentToDeviceInventoryBluePrintV3([this.targetInventory]).subscribe(
      (inventories: any[]) => {
        this.getTerraformCodeByObjV3(inventories?.[0], 'Source');
        this.getTerraformCodeByObjV3(this.targetInventory, 'Target');
      },
      () => {
        this.compareDataV3.SourceCode = '';
        this.compareDataV3.TargetCode = '';
        this.requestCompletedConfigurationV3 = 2;
      }
    );
  }

  getTerraformCodeByObjV3(data, type: string = 'Source') {
    if (!data) {
      this.compareDataV3[type + 'Code'] = '';
      this.requestCompletedConfigurationV3 = ++this.configurationCounterV3;
      return;
    }

    this.blueprintService.getTerraformCode({inventory: data}).subscribe((response: any) => {
      this.compareDataV3[type + 'Code'] = this.getGeneratedCode(response);
      this.requestCompletedConfigurationV3 = ++this.configurationCounterV3;
    }, () => {
      this.compareDataV3[type + 'Code'] = '';
      this.requestCompletedConfigurationV3 = ++this.configurationCounterV3;
    });
  }

  set requestCompletedConfigurationV3(val: number) {
    if (val === 2) {
      this.configurationLoaderV3 = true;
      this.loadingOption3 = false;
      this.loadedOption3 = true;
    }
  }

  compareInventory() {
    this.deviceService.applyDeploymentToDeviceInventoryBluePrint([this.targetInventory]).subscribe(
      (inventories: any[]) => {
        this.getTerraformCode(this.sourceInventoryId, 'Source');
        this.getTerraformCodeByObj(inventories?.[0], 'Target');
      },
      () => {
        this.compareData.SourceCode = '';
        this.compareData.TargetCode = '';
        this.requestCompletedConfiguration = 2;
      }
    );
  }

  getTerraformCode(inventoryId, type: string = 'Source') {
    if (!inventoryId || inventoryId === 'null' || inventoryId === 'undefined') {
      this.compareData[type + 'Code'] = '';
      this.requestCompletedConfiguration = ++this.configurationCounter;
      return;
    }

    this.inventoryService.getTerraformCodeById(inventoryId, true).subscribe(
      (res) => {
        this.compareData[type + 'Code'] = this.getGeneratedCode(res);
        this.requestCompletedConfiguration = ++this.configurationCounter;
      },
      () => {
        this.compareData[type + 'Code'] = '';
        this.requestCompletedConfiguration = ++this.configurationCounter;
      }
    );
  }

  getTerraformCodeByObj(data, type: string = 'Source') {
    if (!data) {
      this.compareData[type + 'Code'] = '';
      this.requestCompletedConfiguration = ++this.configurationCounter;
      return;
    }

    this.blueprintService.getTerraformCode({inventory: data}).subscribe((response: any) => {
      this.compareData[type + 'Code'] = this.getGeneratedCode(response);
      this.requestCompletedConfiguration = ++this.configurationCounter;
    }, () => {
      this.compareData[type + 'Code'] = '';
      this.requestCompletedConfiguration = ++this.configurationCounter;
    });
  }

  getGeneratedCode(response: any) {
    return response && typeof response.result === 'string' ? response.result : '';
  }

  hasCompareData(compareData: any) {
    return !!(
      compareData &&
      (
        (compareData.SourceCode || '').trim() ||
        (compareData.TargetCode || '').trim()
      )
    );
  }

  getHeight(height: number = 0) {
    const height_inner = (window.innerHeight - height).toString();
    return height_inner + 'px';
  }

  onToggleChange(change) {
    this.isEditorShowSeprate = false;
    if (change.checked) this.isEditorShowSeprate = true;
  }

  onToggleChangeOption2(change) {
    this.isEditorShowSeprateOption2 = false;
    if (change.checked) this.isEditorShowSeprateOption2 = true;
  }

  onToggleChangeOption3(change) {
    this.isEditorShowSeprateOption3 = false;
    if (change.checked) this.isEditorShowSeprateOption3 = true;
  }

  set requestCompletedConfiguration(val: number) {
    if (val === 2) {
      this.configurationLoader = true;
    }
  }
}
